import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";
import HeaderAction from "../components/HeaderAction";
import title from "../../../../assets/images/Event-2025/title-prize-collection.png";
import bgHeaderDesktop from "../../../../assets/images/Event-2025/bg-prize-collection-desktop.png";
import bgHeader from "../../../../assets/images/Event-2025/bg-prize-collection.png";
import iconWinner from "../../../../assets/images/Event-2025/icon-winner.png";
import iconBot1 from "../../../../assets/images/Event-2025/img-bg-bot1.png";
import iconBot2 from "../../../../assets/images/Event-2025/img-bg-bot2.png";
import iconBot3 from "../../../../assets/images/Event-2025/img-bg-bot3.png";
import iconBot4 from "../../../../assets/images/Event-2025/img-bg-bot4.png";
import BgDetailPrize from "../../../../assets/images/Event-2025/bg-detail-prize.png";
import { dataListProduct } from "../components/DefineData";
import iconClock from "../../../../assets/images/Event-2025/icon-clock.png";
import iconHome from "../../../../assets/images/Event-2025/icon-home.png";
import ComponentLink from "../components/ComponentLink";
import { useNavigate } from "react-router";
import PATH from "../../../../config/PATH";
import {
  ID_TAB_EVENT_THINGYAN_2025,
  POPUP_VARIANT_EVENT_THINGYAN_2025,
} from "../../../../helper/const";
import WinnerComponent from "../components/Winner";
import PopupCommon from "../components/Popup/PopupCommon";
import MissionsList from "../components/MissionsList";
import MissionCard from "../components/MissionCard";
import iconFooter from "../../../../assets/images/Event-2025/icon-bg-footer.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  getConfigEventThingyan,
  getPrizeCollection,
  postChangeAttemptByBid,
} from "../../../../Redux/futures/thingyan-2025/action";
import {
  curStateAccount,
  curStateEventThingyan2025,
} from "../../../../Redux/selector";
import { useMediaQuery } from "../../../../utils/hooks";
import { getTurnRemain } from "../../../../Redux/futures/account/actions";
import PopupCongrats from "../components/Popup/PopupCongrats";
import PopupError from "../components/Popup/PopupError";
import { t } from "i18next";

export default function PrizeCollection({ setOpenModalLogin }) {
  const isMobile = useMediaQuery("(max-width: 768px");
  const [isShowPopupHistory, setIsShowPopupHistory] = useState(false);
  const selectorAccount = useSelector(curStateAccount);
  
  const [isShowPopupConfirm, setIsShowPopupConfirm] = useState(false);
  const [isShowPopupCongrat, setIsShowPopupCongrat] = useState(false);
  const [bid, setBid] = React.useState(1);
  const [isShowPopupZeroBid, setIsShowPopupZeroBid] = useState(false);
  const [bidTotal, setBidTotal] = useState(0);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { dataPrizeCollection } = useSelector(curStateEventThingyan2025) || {};

  useEffect(() => {
    if (selectorAccount.userInfo) {
      dispatch(getPrizeCollection());
    }
  }, [selectorAccount.userInfo]);

  useEffect(() => {
    if (selectorAccount.remainTurn) {
      const bidTotal = selectorAccount.remainTurn?.reduce((acc, pack) => {
        return acc + pack?.turn;
      }, 0);
      setBidTotal(bidTotal);
    }
  }, [selectorAccount.remainTurn]);

  const handleTopage = () => {
    navigate(`${PATH.EVENT_THINGYAN}/${ID_TAB_EVENT_THINGYAN_2025.home}`);
  };

  const dataLink = [
    {
      id: 1,
      srcImg: iconClock,
      action: () => setIsShowPopupHistory(true),
      content: "History",
      height: 90,
    },
    {
      id: 2,
      srcImg: iconHome,
      action: handleTopage,
      content: "Homepage",
      height: 90,
    },
  ];

  const dataFormatPrize = useMemo(() => {
    const format = dataListProduct.map((item) => {
      const idDefine = item.id;
      const data = dataPrizeCollection.find((item) => +item.id === +idDefine);

      return {
        ...item,
        key: data?.key,
        totalPieceApi: data?.piece_number,
        totalNum: data?.total_num,
        collected: data?.collected,
        receivedPiece: data?.received_num,
      };
    });
    const sortData = format.sort((a, b) => a.id - b.id);
    return sortData;
  }, [dataPrizeCollection]);

  const handeDetailItem = (id) => {
    navigate(
      `${PATH.EVENT_THINGYAN}/${ID_TAB_EVENT_THINGYAN_2025.prizeCollection}/${id}`
    );
  };

  const handleGetAttemp = () => {
    dispatch(getConfigEventThingyan());
  };
  const afterChangeBid = (data, isLoading, dataError) => {
    if (data && data?.success) {
      setIsShowPopupConfirm(false);
      setIsShowPopupCongrat(true);
      handleGetAttemp();
      dispatch(getTurnRemain({}));
    }
  };
  const handleCancelPopup = () => {
    setIsShowPopupCongrat(false);
    setBid(1);
  };
  const handleChangeBid = (totalBidChange) => {
    if (!selectorAccount.userInfo) {
      return setOpenModalLogin(true);
    }
    if (bidTotal === 0) {
      return setIsShowPopupZeroBid(true);
    }
    setBid(totalBidChange);
    setIsShowPopupConfirm(true);
  };
  const handleConfirm = () => {
    const dataApi = {
      callback: afterChangeBid,
      bid_number: bid,
    };
    dispatch(postChangeAttemptByBid(dataApi));
  };

  return (
    <>
      {isShowPopupConfirm ? (
        <PopupCongrats
          open={isShowPopupConfirm}
          onCancel={() => setIsShowPopupConfirm(false)}
          handleActionBtn={handleConfirm}
          variant={POPUP_VARIANT_EVENT_THINGYAN_2025.congratsChangeBid}
          totalBid={bid}
          getContainer={true}
        />
      ) : null}

      {isShowPopupZeroBid ? (
        <PopupError
          open={isShowPopupZeroBid}
          onCancel={() => setIsShowPopupZeroBid(false)}
          handleActionBtn={() => navigate(PATH.PACKAGE)}
          variant={POPUP_VARIANT_EVENT_THINGYAN_2025.noBids}
          getContainer={true}
        />
      ) : null}

      {isShowPopupCongrat ? (
        <PopupCongrats
          open={isShowPopupCongrat}
          onCancel={handleCancelPopup}
          handleActionBtn={handleCancelPopup}
          variant={POPUP_VARIANT_EVENT_THINGYAN_2025.congratsCoin}
          totalBid={bid}
          getContainer={true}
          missionName={
            bid !== 1 ? "Turns နှင့် coins လဲမည်။" : "Turns နှင့် coins လဲမည်။"
          }
        />
      ) : null}

      <Container className="container-thingyan">
        {isShowPopupHistory ? (
          <PopupCommon
            isOpenPopup={isShowPopupHistory}
            handleCancel={() => setIsShowPopupHistory(false)}
            variant={POPUP_VARIANT_EVENT_THINGYAN_2025.activityHistory}
          />
        ) : null}
        <div className="prize-collection-container">
          <div className="header-take-prize">
            <HeaderAction />
          </div>

          <div className="bg-header-container">
            <div className="title-header">
              <img src={title} alt="" />
            </div>
            <img
              src={isMobile ? bgHeader : bgHeaderDesktop}
              alt=""
              className="bg-header"
            />
            {!isMobile && <div className="bg-header-desktop" />}
            <WinnerComponent />
          </div>
          <div className="body-prize-collection">
            <img src={iconBot1} alt="" className="icon-bot-1" />
            <img src={iconBot2} alt="" className="icon-bot-2" />
            <img src={iconBot3} alt="" className="icon-bot-3" />
            <img src={iconBot4} alt="" className="icon-bot-4" />

            <div className="main-content-collection">
              <div className="prize-detail-container">
                {dataFormatPrize?.map((item = {}, index) => {
                  return (
                    <div className="detail-item" key={item.key}>
                      <div
                        className="m-content"
                        onClick={() => handeDetailItem(item.id)}
                      >
                        <div className="item">
                          <img
                            src={BgDetailPrize}
                            alt=""
                            className="bg-prize"
                          />
                          <img
                            src={item.srcImg}
                            alt={item.content}
                            className="detail-prize"
                          />
                        </div>
                        <div className="container-detail-piece">
                          <div className="detail-piece">
                            {item.collected || 0}/
                            {item?.totalPieceApi || item.totalPiece}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="main-container-link">
                <ComponentLink dataLink={dataLink} />
              </div>
            </div>
            <div className="main-container-earn">
              <MissionsList
                title={t("event_thingyan.prize_collection.earn_more")}
                hideFooter
                className="missions-list__change"
              >
                <MissionCard
                  type="earn-change-all"
                  handleExecute={handleChangeBid}
                />
              </MissionsList>
            </div>
          </div>
        </div>
        <img src={iconFooter} alt="" className="thingyan-footer" />
      </Container>
    </>
  );
}

const Container = styled.div`
  border-radius: 12px;
  overflow: hidden;

  .content-error-bid {
    color: red;
    font-style: italic;
    font-size: 12px;
    position: absolute;
    bottom: 3px;
  }

  .mission-card .card-title-wrapper .card-title {
    padding-bottom: 10px;
  }

  .card-more-container {
    position: relative;
  }

  .thingyan-footer {
    width: 100%;
  }

  .main-container-link {
    padding-top: 70px;
    padding-bottom: 25px;
  }

  .container-link {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin-bottom: 20px;
  }

  .bg-header-desktop {
    background: linear-gradient(
      0deg,
      rgb(37, 130, 253) 0%,
      rgb(58, 151, 249) 100%
    );
    height: 50px;
    position: relative;
    top: -3px;
  }

  .btn-prize {
    background: linear-gradient(to bottom, #096ef5 0%, #6be1ff 100%) !important;
    height: 92px;
    border: 2px solid #6be1ff !important;
    width: 342px;
    border-radius: 400px;
    position: relative;
    color: white !important;
  }

  .chilren-button {
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.34) 0%,
      rgba(255, 255, 255, 0) 100%
    );
    border-radius: 40px;
    width: calc(100% - 16px);
    height: calc(100% - 16px);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    font-weight: bold;
  }

  /*  */

  .prize-collection-container {
    position: relative;
  }

  .header-take-prize {
    position: absolute;
    width: 100%;
    top: 20px;
    z-index: 2;
  }

  .bg-header {
    width: 100%;
    max-height: 700px;
  }

  .title-header {
    position: absolute;
    top: 32%;
    text-align: center;
    justify-content: center;
    display: flex;
    align-items: center;
    margin: 0 auto;
    width: 100%;
    z-index: 2;

    img {
      width: 447px;
      max-width: 78%;
    }
  }

  .icon-winner__collect {
    width: 80px;
    z-index: 2;
    position: absolute;
    left: 10px;
    bottom: 24%;
  }

  .main-content-collection {
    padding: 0 18px;
    margin-top: -80px;
    max-width: 964px;
    margin: 0 auto;
  }

  .body-prize-collection {
    background-color: #2582fd;
    position: relative;
    top: -10px;
    border-radius: 0 0 12px 12px;
  }

  .bg-header-container {
    position: relative;
    z-index: 1;
  }

  .icon-bot-1 {
    position: absolute;
    left: -40px;
    top: 50px;
    z-index: 3;
  }
  .icon-bot-2 {
    position: absolute;
    right: 3%;
    top: 60px;
    z-index: 3;
  }
  .icon-bot-3 {
    position: absolute;
    left: -40px;
    top: 500px;
    z-index: 3;
  }

  .icon-bot-4 {
    position: absolute;
    right: 10px;
    top: 400px;
  }

  .prize-detail-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
  }

  .detail-item {
    width: max-content;
    .item {
      width: max-content;
      position: relative;
      /* max-height: 178px; */
    }
  }

  .detail-item:nth-child(3),
  .detail-item:nth-child(7) {
    /* width: 178px; */
  }

  .detail-item:nth-child(1),
  .detail-item:nth-child(2) {
    width: calc(50% - 10px); // 2 item đầu tiên mỗi cái chiếm 50%
  }

  .detail-item:nth-child(1),
  .detail-item:nth-child(3),
  .detail-item:nth-child(6) {
    display: flex;
    justify-content: end;
  }

  .detail-prize {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    max-width: 95%;
    z-index: 10;
  }

  .bg-prize {
    z-index: 20;
    position: relative;
  }

  .container-detail-piece {
    background: linear-gradient(
      to bottom,
      #92c5fa 0%,
      rgba(146, 197, 250, 0) 100%
    );
    position: relative;
    z-index: 21;
    bottom: 18px;
    width: 116px;
    height: 40px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 52px;
    overflow: hidden;
  }

  .detail-piece {
    background: linear-gradient(to bottom, #68a8ff 0%, #368bff 100%);
    height: 36px;
    width: 112px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    position: absolute;
    left: 50%;
    border-radius: 52px;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .m-content {
    width: max-content;
    cursor: pointer;
  }

  @media (min-width: 1400px) {
    .prize-detail-container {
      /* display: grid;
      grid-template-columns: auto auto auto auto auto;
      justify-content: center; */
      display: grid;
      grid-template-columns: repeat(5, 1fr); /* 5 cột cho dòng đầu */
      /* grid-auto-rows: auto;  */
      justify-content: center;

      .detail-item:nth-child(6),
      .detail-item:nth-child(8) {
        grid-column: span 2;
      }

      .detail-item:nth-child(6) {
        margin-left: auto;
      }
    }

    .detail-item:nth-child(1),
    .detail-item:nth-child(2) {
      /* width: 178px; */
      width: auto;
    }

    .detail-item {
      margin: 0 auto;
    }
  }

  @media (min-width: 992px) {
    .m-content:hover {
      transition: 0.3s ease-in-out;
    }
    .card-button:hover {
      opacity: 0.8;
      transition: 0.3s ease-in-out;
    }
  }

  @media (max-width: 992px) {
    margin-bottom: 150px;
  }

  @media (max-width: 576px) {
    .detail-item .item,
    .bg-prize {
      height: 140px;
    }

    .link-img{
      height: 77px !important;
    }

    .detail-item:nth-child(3),
    .detail-item:nth-child(7) {
      width: 140px;
    }

    .detail-prize {
      max-width: 100px;
    }

    .main-container-link {
      padding-top: 35px;
    }
  }

  @media (max-width: 400px) {
    .prize-detail-container {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      justify-content: center;

      .detail-item:nth-child(6) {
        margin-left: auto;
      }
    }

    .detail-item:nth-child(1),
    .detail-item:nth-child(2) {
      width: auto;
    }

    .detail-item {
      margin: 0 auto;
    }

    .main-content-collection {
      margin-top: -50px;
    }
  }

  @media (min-width: 1400px) {
    .detail-item:nth-child(6) {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: end;
    }

    .detail-item:nth-child(8) {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: start;
    }

    .prize-detail-container {
      margin-top: -85px;
    }
  }
`;
